(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ev-universal-mega-menu"]) return;
  try {
    
  const initializeEvMega = (root = document) => {
    root.querySelectorAll('[data-ev-mega]').forEach((mega) => {
      if (mega.dataset.evMegaInitialized === 'true') return;
      mega.dataset.evMegaInitialized = 'true';

      const tabs = Array.from(mega.querySelectorAll('[data-ev-mega-tab]'));
      const panels = Array.from(mega.querySelectorAll('[data-ev-mega-panel]'));

      const activate = (tab, moveFocus = false) => {
        const panelId = tab.dataset.panelId;

        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = panel.id === panelId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        const promoSrc = tab.dataset.evPromoSrc;
        const activePanel = panels.find((panel) => panel.id === panelId);

        if (promoSrc && activePanel) {
          const promoImage = activePanel.querySelector('.ev-mega__promo-image');

          if (promoImage) {
            promoImage.removeAttribute('srcset');
            promoImage.removeAttribute('sizes');
            promoImage.src = promoSrc;
          }
        }

        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', () => activate(tab));
        tab.addEventListener('focus', () => activate(tab));
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            activate(tabs[nextIndex], true);
          }
        });
      });

      const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (initialTab) activate(initialTab);
    });
  };

  initializeEvMega();

  if (window.evMegaLinkNavigationBound !== true) {
    window.evMegaLinkNavigationBound = true;

    window.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('.ev-mega__link, .ev-mega__heading-link, .ev-mega__promo-link, .ev-mega__tile-link, .ev-mega__tab-link');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.open(link.href, '_blank', 'noopener');
        return;
      }

      if (event.button !== 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(link.href);
    }, true);
  }

  document.addEventListener('shopify:section:load', (event) => initializeEvMega(event.target));

  } catch(e) { console.error(e); }
})();
})();
